import pluralize from 'pluralize';

export default {
  methods: {
    arrayNotEmpty(array) {
      return array && array.length;
    },
    mergeTargetProps(target, source) {
      const newObject = {};
      Object.keys(target)
        .forEach((key) => {
          let value = (key in source ? source : target)[key];
          if (typeof target[key] === 'object' && target[key] !== null && !value) value = target[key];
          if (Array.isArray(target[key]) && !value) value = target[key];
          newObject[key] = value;
        });
      return newObject;
    },
    joinList(list) {
      if (list.length < 3) return list.join(' and ');
      const csv = list.slice(0, -1).join(', ');
      return [csv, list[list.length - 1]].join(', and ');
    },
    objectAndPropsNotEmpty(object) {
      return Object.values(object)
        .map(value => (Array.isArray(value) ? value.length : value))
        .reduce((acc, value) => value || acc, false);
    },
    pluralizeMultiple(singular, array) {
      return (array && array.length > 1) ? pluralize(singular) : singular;
    },
    localeString(number) {
      return number.toLocaleString('en-US');
    },
    hasExtension(filename, extension) {
      return filename.toLowerCase().endsWith(extension);
    },
    disableTabbing(element) {
      if (!element) return;

      const focusableElements = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
      const elements = element.querySelectorAll(focusableElements);
      elements.forEach((element) => {
        element.setAttribute('tabindex', '-1');
        element.setAttribute('disabled', 'true');
      });
    },
  },
};
